import "../styles.scss";
import "./dataOphalen.js";
import "babel-polyfill";